import { useState } from "react";
import p3 from "~/assets/ai/p3@3x.png";
import p3m from "~/assets/ai/p3-m@3x.png";
import p5 from "~/assets/ai/p5@3x.png";
import p6 from "~/assets/ai/p6@3x.png";
import p7 from "~/assets/ai/p7@3x.png";
import p8 from "~/assets/ai/p8@3x.png";
import p9 from "~/assets/ai/p9@3x.png";
import p10 from "~/assets/ai/p10.png";
import p11 from "~/assets/ai/p11@3x.png";
import p19 from "~/assets/fullstack/p11@3x.png";
import p20 from "~/assets/fullstack/p12@3x.png";

import SiteLayout from "components/layout/SiteLayout";

import { Collapse } from "antd";
const { Panel } = Collapse;

const Page = () => {
  const [active, setActive] = useState<string>("left");
  const [accordions, setAccordions] = useState<boolean[]>([]);
  const toggleState = (i: number) => {
    const newAccordions = [...accordions];
    newAccordions[i] = !newAccordions[i];
    setAccordions(newAccordions);
  };
  const pageScrollBottom = () => {
    window.scroll({
      top: document.body.scrollHeight,
      left: 0,
      behavior: "smooth",
    });
  };
  return (
    <SiteLayout largeContainer="true">
      <div className="ai-wrapper">
        <div className="block1">
          <div className="content">
            <div className="left">
              <div className="text">AI 大模型使用&开发实战营</div>
              <div className="text-en">AI LARGE MODEL USE &DEVELOPMENT OF</div>
              <div className="text-en"> ACTUAL COMBAT CAMP</div>
              <div className="learn-btn" onClick={pageScrollBottom}>
                我想学习&gt;
              </div>
            </div>
            <img src={p3.src} className="p3" />
          </div>
          <img src={p3m.src} className="p3m" />
        </div>
        <div className="block2">
          <div className="content">
            <div className="title-w title-pc">
              <div className="title">课程收获</div>
            </div>
            <div className="list-content">
              <div className="list-w">
                <div className="item">
                  <div className="p5">
                    <img src={p5.src} />
                    <div>1</div>
                  </div>
                  <div className="text">
                    带你学会使用chatgpt、midjourney、stable diffusion等AI
                    工具，为工作提效
                  </div>
                </div>
                <div className="item">
                  <div className="p5">
                    <img src={p5.src} />
                    <div>2</div>
                  </div>
                  <div className="text">
                    全面掌握大模型应用开发框架LangChain
                  </div>
                </div>
                <div className="item">
                  <div className="p5">
                    <img src={p5.src} />
                    <div>3</div>
                  </div>
                  <div className="text">
                    从设计到部署，深度实践大模型应用开发落地全流程
                  </div>
                </div>
                <div className="item">
                  <div className="p5">
                    <img src={p5.src} />
                    <div>4</div>
                  </div>
                  <div className="text">手把手带你实现模型微调</div>
                </div>
                <div className="item">
                  <div className="p5">
                    <img src={p5.src} />
                    <div>5</div>
                  </div>
                  <div className="text">
                    构建一个具有LangChain、OpenAI和Hugging Face
                    Spaces的动态问答应用。
                  </div>
                </div>
              </div>
              <img className="p6" src={p6.src} />
            </div>
          </div>
        </div>
        <div className="block3">
          <div className="content">
            <div className="title-w title-pc">
              <div className="title">适合人群</div>
            </div>
            <div className="list-w">
              <div className="item">
                <img src={p7.src} />
                <div className="line"></div>
                <div className="text text-1">前后端开发工程师</div>
              </div>
              <div className="item">
                <img src={p8.src} />
                <div className="line"></div>
                <div className="text">
                  需要结合大模型相关技术为业务附能的PM、UI、运营同学
                </div>
              </div>
              <div className="item item-1">
                <img src={p9.src} />
                <div className="line"></div>
                <div className="text text-1">
                  任何热衷于使用 Langchain 构建人工智能驱动的 LLM 应用程序的人
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="block4">
          <div className="content">
            <div className="title-w title-pc">
              <div className="title">课程介绍</div>
            </div>
            <Collapse ghost>
              <Panel
                className={`panel ${!accordions[0] && "without-line"}`}
                showArrow={false}
                key={0}
                header={
                  <div className="ac-item-title" onClick={() => toggleState(0)}>
                    <div>入门必备使用篇</div>
                    {accordions[0] ? (
                      <img src={p19.src} />
                    ) : (
                      <img src={p20.src} className="p12" />
                    )}
                  </div>
                }
              >
                <div className="ac-item">
                  <div className="list-w">
                    <div className="item">
                      <p>1. chatgpt、midjourney的注册</p>
                      <p>2. 让Al做你的翻译官</p>
                      <p>3. 用Al写小说、写工作总结</p>
                      <p>4. 用AI做出精美的PPT及演讲稿</p>
                      <p>5. 用Al整理会议内容形成会议纪要</p>
                      <p>6. 用Al为Excel赋能</p>
                    </div>
                    <div className="item">
                      <p>7. 用Al做市场调研和需求分析</p>
                      <p>8. 用AI写story、title、营销文案</p>
                      <p>9. 用stable diffusion生成AI模特的服装搭配</p>
                      <p>10. AI一键自动生成高质量视频</p>
                      <p>11. AI绘画mid基础操作之操作指令和设置解析</p>
                    </div>
                  </div>
                </div>
              </Panel>
              <Panel
                className={`panel ${!accordions[1] && "without-line"}`}
                showArrow={false}
                key={1}
                header={
                  <div className="ac-item-title" onClick={() => toggleState(1)}>
                    <div>深入学习理论篇</div>
                    {accordions[1] ? (
                      <img src={p19.src} />
                    ) : (
                      <img src={p20.src} className="p12" />
                    )}
                  </div>
                }
              >
                <div className="ac-item">
                  <div className="list-w">
                    <div className="item">
                      <p>1. 大模型的发展历程、背景、进展</p>
                      <p>2. 模型中的注意力机制</p>
                      <p>3. Transformer 解析、应用</p>
                      <p>4. GPT 与 Bert</p>
                    </div>
                    <div className="item">
                      <p>5. GPT-1、GPT-2 、GPT-3 、GPT-4</p>
                      <p>6. 多模态：从CLIP、BLIP到DALL</p>
                      <p>
                        7. 通俗理解stable diffusion，文本到图像的潜在扩散模型
                      </p>
                    </div>
                  </div>
                </div>
              </Panel>
              <Panel
                className={`panel ${!accordions[2] && "without-line"}`}
                showArrow={false}
                key={2}
                header={
                  <div className="ac-item-title" onClick={() => toggleState(2)}>
                    <div>商业实战篇</div>
                    {accordions[2] ? (
                      <img src={p19.src} />
                    ) : (
                      <img src={p20.src} className="p12" />
                    )}
                  </div>
                }
              >
                <div className="ac-item">
                  <div className="y-title">
                    构建一个具有LangChain、OpenAI和Hugging Face
                    Spaces的动态问答应用。
                  </div>
                  <div className="list-w">
                    <div className="item">
                      <p>1. LangChain 基础理论</p>
                      <p>2. LangChain 架构与设计</p>
                      <p>3. 如何将 LangChain 应用于开发</p>
                      <p>4. Models、LLMs、Chat Models 等核心概念</p>
                      <p>5. Prompt Templates 与 Example Selectors</p>
                      <p>6. Chains 与 Agents</p>
                      <p>7. 利用 Indexes 检索非结构化数据</p>
                      <p>8. 如何使用 Retrievers 实现数据检索</p>
                      <p>9. 使用 Callbacks 实现复杂的控制流</p>
                      <p>10. 如何为应用赋予一定的记忆能力</p>
                    </div>
                    <div className="item">
                      <p>11. 项目需求与规划</p>
                      <p>12. 技术方案与架构设计</p>
                      <p>13. 实践项目开发</p>
                      <div className="pc-item">
                        <p>· 利用 LangChain LLMs 接入模型</p>
                        <p>· 使用 LangChain Prompt Templates</p>
                        <p>· 使用 LangChain Example Selectors 引导输入</p>
                        <p>· 利用 Example Selectors 引导用户输入</p>
                        <p>· 提高用户交互的质量与效率</p>
                        <p>· 使用 LangChain Callbacks 实现异常捕获</p>
                      </div>
                    </div>
                  </div>
                  <div className="y-title y-title-sm">大模型应用的合法合规</div>
                  <div className="list-w">
                    <div className="item">
                      <p>1. 数据隐私与保护措施</p>
                      <p>2. 大模型的可解释性与审计性</p>
                      <p>3. 如何使模型的决策过程更透明</p>
                    </div>
                    <div className="item">
                      <p>4. 伦理与法规合规性</p>
                      <p>5. 数据隐私的量化评估</p>
                    </div>
                  </div>
                  <div className="y-title y-title-sm">模型微调实战</div>
                  <div className="list-w">
                    <div className="item">
                      <p>1. 大模型并行训练基础理论</p>
                      <p>2. 收集数据、处理数据、利用数据</p>
                      <p>3. ChatGLM2-6B的基座、部署、微调、实现</p>
                    </div>
                    <div className="item">
                      <p>4. 模型优化、评估、上线</p>
                      <p>5. 部署、微调stable diffusion</p>
                    </div>
                  </div>
                </div>
              </Panel>
            </Collapse>
          </div>
        </div>
        <div className="block7">
          <div className="content">
            <div className="title-w title-pc">
              <div className="title">课程导师</div>
            </div>
            <div className="list-w">
              <div className="item">
                <div className="name">Noah</div>
                <div className="text">
                  8年架构师和技术管理经验，先后供职于互联网大厂、大型国企，后自己创业。
                </div>
                <div className="text">
                  参与和主导过数十个云计算、电商、钢铁、能源、物联网等多领域大型项目，积累了非常丰富的项目实战经验。
                </div>
                <div className="text">
                  22 年进入 AIGC 领域创业，成功创办了多个盈利可观的 AIGC
                  项目，现专注于 AIGC 在不同行业中的实际应用和整合。
                </div>
              </div>
              <img src={p10.src} className="p10" />
            </div>
          </div>
        </div>
        <div className="block8">
          <div className="content">
            <div className="list-w">
              <div className="item">
                <div className="price">价格</div>
                <div className="price-list">
                  <div>入门必备使用篇：￥899</div>
                  <div>深入学习理论篇：￥499</div>
                  <div>商业实战篇：￥1099</div>
                  <div>三篇一起报名打9折: ￥2247</div>
                </div>
              </div>
              <div className="item item-right">
                <img src={p11.src} />
                <div className="contact-text">
                  <div>有疑问或报名参加</div>
                  <div>请联系训练营负责人</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
};
export default Page;
